// --------------------------------------------------------------------------
// updateExhibitsDate.js
// --------------------------------------------------------------------------

RN.updateExhibitsDate = function() {

  'use strict';

  var dateElement;

  function init() {
    byBehaviour('update-exhibits-date').on('change', updateDate);
    dateElement = byElement('exhibits-date');
  }

  function updateDate() {

    var d = moment(parseDate(this.value)),
        display = d.format("MMMM Do, YYYY"),
        isToday = d.isSame(new Date(), "day");

    if(isToday){
      display = "Today, " + display;
    }

    dateElement.text(display);
  }

  function parseDate(input) {
    var parts = input.match(/(\d+)/g);
    return new Date(parts[0], parts[1]-1, parts[2]);
  }

  return {
    init: init
  };

}();